import CloseIcon from "@mui/icons-material/Close";
import StyledButton from "components/shared/StyledButton";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

type TProps = {
    isOpen: boolean;
    drawerLeft: number;
    onClose: () => void;
};

const CollectiveManagementInfoModal = ({ isOpen, drawerLeft, onClose }: TProps) => {
    const [t] = useTranslation();

    if (!isOpen) return null;

    return createPortal(
        <div
            style={{
                position: "fixed",
                top: 0,
                right: 0,
                bottom: 0,
                left: drawerLeft,
                zIndex: 1300,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    borderRadius: "6px",
                    fontFamily: "Poppins, sans-serif",
                    width: "400px",
                    maxWidth: "calc(100% - 32px)",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "16px 40px",
                        borderBottom: "1px solid #e5e7eb",
                    }}
                >
                    <h2
                        style={{
                            fontSize: "1rem",
                            fontWeight: 500,
                            margin: 0,
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        {t("Summary.CollectiveManagementDifferenceModalTitle")}
                    </h2>
                    <CloseIcon
                        onClick={onClose}
                        sx={{
                            cursor: "pointer",
                            color: "#B4B4B4",
                            "&:hover": { color: "#626262" },
                            transition: "0.4s",
                        }}
                    />
                </div>
                <div style={{ padding: "20px 40px 32px" }}>
                    <p
                        style={{
                            fontSize: "0.875rem",
                            color: "#6b7280",
                            marginBottom: "32px",
                            fontFamily: "Poppins, sans-serif",
                            lineHeight: "1.5",
                        }}
                    >
                        {t("Summary.CollectiveManagementDifferenceTooltip")}
                    </p>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <StyledButton buttonType="primary" onClick={onClose}>
                            {t("Summary.GotIt")}
                        </StyledButton>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default CollectiveManagementInfoModal;
